import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6 doesn't reset scroll on navigation, so each new page
// renders at whatever offset the previous page was scrolled to. Mount this
// once inside <BrowserRouter> and every pathname change snaps to top.
// Hash links are preserved so anchor scrolling still works.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};
